module.exports = __webpack_public_path__ + "static/media/pro-saber.0624852d.png";